import {Positionable, SimpleReelModelSymbolPosition} from "../../../core/reel/simplereel/SimpleReelModel";
import {Reel} from "../Reel";
import {gsap} from "gsap";
import {XwaysHoarder2Statics} from "../../XwaysHoarder2Statics";
import {XwaysHoarder2} from "../../XwaysHoarder2";
import {XwaysHoarder2GameAssets} from "../../XwaysHoarder2GameAssets";


export enum SymbolStates {
    NORMAL = "NORMAL",
    SPIN = "SPIN",
    WIN = "WIN",
    START_SPIN = "START_SPIN",
    NO_WIN = "NO_WIN",
    WIN_TOGGLE = "WIN_TOGGLE",
    LANDING = "LANDING",
    REVEAL = "REVEAL",
    STICKY = "STICKY",
    UNSTICKY = "UNSTICKY",
    SPLIT = "SPLIT",
    REVERT = "REVERT",
    SCALED = "SCALED",
    REVERSE_SCALED = "REVERSE_SCALED",
    REMOVED = "REMOVED",
    NUDGE = "NUDGE",
    START_SPLIT = "START_SPLIT"
}


export class BasicSymbol implements Positionable {
    public position: PIXI.ObservablePoint;
    public symbolName: string;
    public symID: number = -1;
    public mainSpriteContainer: PIXI.Container;
    public mainSpine: PIXI.spine.Spine | null;
    public view: PIXI.Container;
    public visualHeightStatus: number;
    public isSticky: boolean = false;
    public isOldSym: boolean = false;
    public symbolHeight: number = 1;//no of space it fills in terms of symbol count in a reel
    public splitAnimOn: boolean;
    public isSplitted: boolean;
    public isScaled: boolean = false;
    reel: Reel;
    protected overlayContainer: PIXI.Container;
    protected symbolSize: number = 1;//multiplier counter
    protected noWinOverlay: PIXI.Sprite | null;

    constructor(symbolName: string, initState: SymbolStates, reel: Reel, symbolPosition: SimpleReelModelSymbolPosition) {


        this.reel = reel;
        this.symbolName = symbolName;
        this.position = new PIXI.ObservablePoint(this.onPosition, this, 0, 0);
        this.symID = symbolPosition.position;


        this.init();
        // this.moveToNormalLayer();
    }

    get symSize(): number {
        return this.symbolSize;
    }

    set symSize(value: number) {
        this.symbolSize = value;
    }

    private _mainSprite: PIXI.Sprite;

    get mainSprite(): PIXI.Sprite {
        return this._mainSprite;
    }

    set mainSprite(value: PIXI.Sprite) {
        this._mainSprite = value;
    }

    private _state: SymbolStates;

    get state(): SymbolStates {
        return this._state;
    }

    set state(value: SymbolStates) {
        this._state = value;
    }

    public onPosition() {
        this.view.position.set(this.position.x, this.position.y); //  + this.xWayOffset.y
    }

    public moveToNormalLayer(object: PIXI.DisplayObject = this.view, override: boolean = false) {
        this.isSticky = false;
        this.reel.layers.maskedNormal.addChild(object);
    }

    public moveToLockOverlayLayer(object: PIXI.DisplayObject = this.view, override: boolean = false) {
        this.reel.layers.lockOverlay.addChild(object);
    }

    public moveToNormalOverLayer(object: PIXI.DisplayObject = this.view, override: boolean = false) {
        this.reel.layers.maskedOver.addChild(object);
    }

    public moveToOverlayLayer(object: PIXI.DisplayObject = this.view, override: boolean = false) {
        this.reel.layers.overlay.addChild(object);
    }

    public moveToStickyLayer(object: PIXI.DisplayObject = this.view) {
        this.isSticky = true;
        object.name = `sticky_${this.symbolName}`;
        this.reel.layers.stickyOverlay.addChild(object); // XwaysHoarder2.winView.addChild(object);
    }

    public hide(): void {
        this.moveToNormalLayer();
        this._mainSprite.visible = false;
        this.view.visible = false;
    }


    public removeFromStickyLayer(): void {
        this.isSticky = false;
        this.reel.layers.stickyOverlay.removeChildren();
    }

    public unSticky(onlyLayer: boolean = false, textureName?: string): gsap.core.Timeline {
        const tl = gsap.timeline();
        this.isSticky = false;
        this.reel.layers.stickyOverlay.removeChildren();
        tl.add([
            () => this.moveToNormalLayer()
        ]);


        return tl;
    }


    public hideNoWinOverlay(duration: number = 0.1): gsap.core.Timeline {
        const tl = gsap.timeline();
        if (this.noWinOverlay !== null) {
            tl.to(this.noWinOverlay, {duration: duration, alpha: 0, ease: "none"});
            tl.add(() => {
                this.view.removeChild(this.noWinOverlay!);
                this.noWinOverlay?.destroy();
                this.noWinOverlay = null;
            }, ">");
        }
        return tl;
    }

    public getStateAnimation(state: SymbolStates, textureName?: string): gsap.core.Timeline {
        const tl: gsap.core.Timeline = gsap.timeline();

        if (tl.duration() == 0) {
            tl.add(gsap.to(this, {duration: 0.0001}));
        }

        return tl;
    }

    destroy(options?: { children?: boolean; texture?: boolean; baseTexture?: boolean }) {
        if (this.view.parent) {
            this.view.parent.removeChild(this.view);
        }

        this.view.destroy(options);
    }

    public isVisibleInReel(): boolean {
        for (let symbolData of this.reel.model.getAllVisibleSymbols()) {
            if (symbolData.positionable === this) {
                return true;
            }
        }
        return false;
    }

    public xSplitFlashEffect(): gsap.core.Timeline {
        const flashTl: gsap.core.Timeline = gsap.timeline();
        const splitFlash: PIXI.spine.Spine = new PIXI.spine.Spine(XwaysHoarder2.assetLoader.getSpineAsset(XwaysHoarder2GameAssets.SPLIT_REEL));

        return flashTl;
    }

    public setSpriteTexture(textureName: string = ""): void {
        if (textureName == "none") {
            this._mainSprite.texture = PIXI.Texture.EMPTY;
        } else {
            this.mainSprite.texture = XwaysHoarder2.assetLoader.getTextures(XwaysHoarder2GameAssets.getSymbolStateTexturePath(this.symbolName, textureName))[0];
        }
    }

    protected init() {

        this.view = new PIXI.Container();
        this.view.name = `view_${this.symbolName}`;

        this.overlayContainer = new PIXI.Container();
        this.overlayContainer.name = "overlayContainer";

        this.mainSpriteContainer = new PIXI.Container();
        this.mainSpriteContainer.name = "mainSpriteContainer";

        this._mainSprite = new PIXI.Sprite(PIXI.Texture.EMPTY);
        this._mainSprite.name = "mainSprite";
        this._mainSprite.position.set(XwaysHoarder2Statics.symbolWidth * 0.5, XwaysHoarder2Statics.symbolHeight * 0.5);
        this._mainSprite.anchor.set(0.5, 0.5);
        this.mainSpriteContainer.addChild(this._mainSprite);

        this.view.addChild(this.mainSpriteContainer);
        this.view.addChild(this.overlayContainer);

    }

    protected moveToWinLayer(object: PIXI.DisplayObject = this.view) {
        this.reel.layers.win.addChild(object);

    }

    protected showNoWinOverlay(tint: number, duration: number = 0.1, alpha: number = 0.7, blendMode: PIXI.BLEND_MODES = PIXI.BLEND_MODES.ADD, isRespin: boolean): gsap.core.Timeline {
        const tl = gsap.timeline();
        this.noWinOverlay = new PIXI.Sprite(PIXI.Texture.WHITE);
        this.noWinOverlay.name = "_noWinOverlay";
        this.noWinOverlay.height = isRespin ? XwaysHoarder2Statics.symbolHeight : this._mainSprite.height;
        this.noWinOverlay.width = isRespin ? XwaysHoarder2Statics.symbolWidth : this._mainSprite.width;
        this.noWinOverlay.position.x = this._mainSprite.position.x;
        this.noWinOverlay.position.y = this._mainSprite.position.y;
        this.noWinOverlay.anchor.set(0.5, 0.5);
        this.noWinOverlay.blendMode = blendMode;
        this.noWinOverlay.alpha = 0;
        this.noWinOverlay.tint = tint;
        this.view.addChild(this.noWinOverlay);
        tl.to(this.noWinOverlay, {duration: duration, alpha: alpha, ease: "none"}, ">");
        return tl;
    }

    private setFirstState(): void {

    }


}